import {Navigate, Outlet, ScrollRestoration, useLocation} from 'react-router-dom';
import CandidateHeader from '../components/CandidateHeader/CandidateHeader';
import useUser from '../hooks/useUser';
import {useState} from 'react';
import Footer from '../components/Footer/Footer';
import rolesConst from '../constants/rolesConst';
import useRoleNavigation from '../hooks/useRoleNavigation';
import routesConst from '../constants/routesConst';

export default function CandidateRoot() {
  const {isUnauthorized, renderUnauthorized} = useRoleNavigation(rolesConst.applicant);
  const {user, isLoading, isError, mutate} = useUser();
  const [hasModuleSaved, setHasModuleSaved] = useState(false);
  const location = useLocation();

  if (isUnauthorized) {
    return renderUnauthorized;
  }

  // Once the user is loaded, check if both clauses have been accepted.
  // If not, and the user is not already on the clauses page, redirect there.
  const isOnClausesPage = location.pathname === routesConst.clausesAcceptance;
  const needsClauseAcceptance =
    !isLoading &&
    !isError &&
    user &&
    (!user.privacyNoticeClauseAccepted ||
      !user.termsAndConditionsClauseAccepted ||
      !user.statementOfTruthClauseAccepted);

  if (needsClauseAcceptance && !isOnClausesPage) {
    return <Navigate to={routesConst.clausesAcceptance} replace />;
  }

  return (
    <>
      <CandidateHeader />
      {!isLoading && !isError && user ? (
        <Outlet context={{hasModuleSaved, setHasModuleSaved, user, mutate}} />
      ) : (
        <div style={{minHeight: '90vh'}}></div>
      )}
      <Footer />
      <ScrollRestoration />
    </>
  );
}
